import type { HelpGuide, InstructionManual, ManualSection } from '@types';
import { HELP_CONTENT } from './helpContent';

export const guideToManualSection = (guide: HelpGuide): ManualSection => ({
    title: guide.title || 'Instructions',
    content: [guide.introduction, ...guide.sections.map(section => `### ${section.title}\n\n${section.content}`)].join('\n\n')
});

export const INSTRUCTION_MANUAL_CONTENT: InstructionManual = {
    title: 'IntelOptics Insights: Admin Instruction Manual',
    introduction: 'Follow the numbered steps for organization management, service review, workspace preparation, and client delivery. Use the controls available to your role.',
    sections: Object.values(HELP_CONTENT).map(guideToManualSection)
};
